import React from "react";

const ArrowsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M4.77927 8.34898L4.77927 3.29179L6.97453 5.48705L7.91734 4.54424L4.1126 0.739502L0.307861 4.54424L1.25067 5.48705L3.44593 3.29179L3.44593 8.34898H4.77927Z"
      fill="#010304"
    />
    <path
      d="M10.1127 5.68231V10.7395L12.308 8.54424L13.2508 9.48705L9.44604 13.2918L5.64131 9.48705L6.58412 8.54424L8.77938 10.7395V5.68231L10.1127 5.68231Z"
      fill="#010304"
    />
  </svg>
);

export default ArrowsIcon;
